"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionHistoryPage = exports.CollectionHistoryPageConfig = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const spinner_1 = require("../components/spinner/spinner");
const i18n_1 = require("../i18n");
const collection_history_table_1 = require("../modules/collection.history.table/collection.history.table");
const services_1 = require("../services");
const index_1 = require("../store/index");
const page_1 = require("./page");
exports.CollectionHistoryPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.collectionHistory,
    path: '/collection/:collectionUuid/history',
    auth: {
        required: true,
        tokens: [core_api_1.IkeToken.FEATURE_REVISION_HISTORY],
        userLevel: [core_api_1.IkeUserRole.DATA_ADMIN, core_api_1.IkeUserRole.ROOT]
    }
};
class CollectionHistoryPage extends page_1.IkePage {
    constructor() {
        super(exports.CollectionHistoryPageConfig);
        this.modificationMessages = mobx_1.observable.map();
        this.userNames = mobx_1.observable.map();
        // Wait for the route params to be available
        this.reaction(() => services_1.Services.Route.params, params => {
            this.collectionUuid = params.get('collectionUuid');
            if (!this.collectionUuid) {
                return;
            }
            // Get the CollectionSummary
            services_1.Services.Department.rest.CollectionSummary.getByUuid(this.collectionUuid).fetch().then(c => {
                this.setCollectionSummary(c);
                // Get the Collection revisions
                index_1.AppStore.Collection.getHistory(c.uuid).then(history => {
                    history.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
                    this.setRevisions(history);
                    // Load usernames
                    history.forEach(r => {
                        var _a, _b, _c;
                        services_1.Services.Department.rest.Department.User.getProfileById(r.updatedBy).fetch().then(user => {
                            this.setUsername(r.updatedBy, user.username);
                        });
                        // Load modification messages
                        if (r.modifications && Object.keys(r.modifications).length) {
                            // Load the moved from department message
                            if ((_a = r.modifications) === null || _a === void 0 ? void 0 : _a.departmentMovedFrom) {
                                services_1.Services.Department.rest.Department.getById({ departmentId: r.modifications.departmentMovedFrom }).then(result => {
                                    this.modificationMessages.set(r.revision, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_MOVED_FROM_DEPARTMENT_MESSAGE, result.results[0].name));
                                });
                            }
                            // Load the reverted to object message
                            if ((_b = r.modifications) === null || _b === void 0 ? void 0 : _b.revisionToRevertTo) {
                                this.modificationMessages.set(r.revision, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_REVERTED_MESSAGE, r.modifications.revisionToRevertTo));
                            }
                            if ((_c = r.modifications) === null || _c === void 0 ? void 0 : _c.formMigrate) {
                                this.modificationMessages.set(r.revision, (0, i18n_1.Translate)(i18n_1.T.COLLECTION_REVISION_HISTORY_FORM_MIGRATED_MESSAGE, { from: r.modifications.formMigrate.from, to: r.modifications.formMigrate.to }));
                            }
                        }
                        else {
                            // Set the modifications to an empty string if none need to be loaded
                            this.modificationMessages.set(r.revision, '');
                        }
                    });
                });
            });
        }, { fireImmediately: true });
    }
    setCollectionSummary(c) {
        this.collectionSummary = c;
    }
    setRevisions(rs) {
        this.revisions = rs;
    }
    setUsername(userId, username) {
        this.userNames.set(userId, username);
    }
    setModificationMessages(revision, message) {
        this.modificationMessages.set(revision, message);
    }
    get nodes() {
        if (services_1.Services.Department.current == null) {
            return null;
        }
        if (!this.collectionSummary || !this.revisions) {
            return spinner_1.Spinner.view();
        }
        return collection_history_table_1.CollectionHistoryTable.view(this.collectionSummary, this.revisions, this.userNames.toPOJO(), this.modificationMessages.toPOJO());
    }
}
exports.CollectionHistoryPage = CollectionHistoryPage;
tslib_1.__decorate([
    mobx_1.observable
], CollectionHistoryPage.prototype, "collectionUuid", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionHistoryPage.prototype, "collectionSummary", void 0);
tslib_1.__decorate([
    mobx_1.observable
], CollectionHistoryPage.prototype, "revisions", void 0);
tslib_1.__decorate([
    mobx_1.action
], CollectionHistoryPage.prototype, "setCollectionSummary", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionHistoryPage.prototype, "setRevisions", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionHistoryPage.prototype, "setUsername", null);
tslib_1.__decorate([
    mobx_1.action
], CollectionHistoryPage.prototype, "setModificationMessages", null);
//# sourceMappingURL=collection.history.page.js.map